import __vue_component__ from '../Form/TextField.vue.js';
import CalendarIcon from '../Icon/CalendarIcon.js';
import isValid from '../../node_modules/date-fns/esm/isValid/index.js';
import format from '../../node_modules/date-fns/esm/format/index.js';
import fromUnixTime from '../../node_modules/date-fns/esm/fromUnixTime/index.js';
import parse from '../../node_modules/date-fns/esm/parse/index.js';
import utcToZonedTime from '../../node_modules/date-fns-tz/esm/utcToZonedTime/index.js';
import zonedTimeToUtc from '../../node_modules/date-fns-tz/esm/zonedTimeToUtc/index.js';
import __vue_component__$1 from './Calendar.vue.js';
import __vue_component__$2 from '../common/Popup.vue.js';

//
const MILISECONDS_IN_SECOND = 1000;
var script = {
  name: 'DatePicker',
  components: {
    TextField: __vue_component__,
    Calendar: __vue_component__$1,
    Popup: __vue_component__$2,
    CalendarIcon
  },
  props: {
    value: {
      type: [Number, String],
      default: undefined
    },
    isFocused: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    dateFormat: {
      type: String,
      default: 'dd/MM/y'
    },
    disabledRange: {
      type: Object,
      default: () => ({
        from: undefined,
        to: undefined
      })
    },
    timeZone: {
      type: String,
      default: undefined
    }
  },

  data() {
    return {
      focused: false,
      isOpen: false
    };
  },

  computed: {
    isValid() {
      return this.value && isValid(this.value);
    },

    selectedDate: {
      get() {
        if (!this.isValid) {
          return undefined;
        }

        return fromUnixTime(this.value / MILISECONDS_IN_SECOND);
      },

      set(date) {
        this.$emit('input', date);
      }

    },

    formattedDate() {
      if (!this.isValid) {
        return '';
      }

      const date = utcToZonedTime(this.value, this.timeZone);
      return format(date, this.dateFormat);
    },

    listeners() {
      const {
        focus,
        blur,
        input,
        ...listeners
      } = this.$listeners;
      return listeners;
    }

  },
  watch: {
    isFocused: {
      handler(isFocused) {
        if (isFocused) {
          this.$nextTick(() => this.$refs.input.focus());
        }
      },

      immediate: true
    }
  },
  methods: {
    onInput(e) {
      const timestamp = parse(e.target.value, this.dateFormat, new Date()).getTime();

      if (e.target.value.length === 0) {
        this.selectedDate = undefined;
      } else if (!Number.isNaN(timestamp)) {
        const formatted = format(timestamp, this.dateFormat);
        if (e.target.value !== formatted) return;
        const date = new Date(timestamp);
        this.copyTime(date);
        const utcDate = zonedTimeToUtc(date, this.timeZone);
        this.selectedDate = utcDate.getTime();
      }
    },

    copyTime(date) {
      if (this.selectedDate) {
        const selectedDate = new Date(this.selectedDate);
        date.setHours(selectedDate.getHours());
        date.setMinutes(selectedDate.getMinutes());
        date.setSeconds(selectedDate.getSeconds());
      }
    },

    toggle() {
      this.isOpen = !this.isOpen;
    },

    onEsc() {
      this.isOpen = false;
    },

    onEnter(e) {
      this.$emit('confirm', e);
    },

    onFocus(e) {
      if (!this.$refs['date-picker'].contains(e.relatedTarget)) {
        this.focused = true;
        this.isOpen = true;
        this.$emit('focus', e);
      }
    },

    onBlur(e) {
      if (!this.$refs['date-picker'].contains(e.relatedTarget)) {
        this.focused = false;
        this.isOpen = false;
        this.$emit('blur', e);
      } else if (e.relatedTarget.getAttribute('tabindex') === '-1') {
        this.$refs.input.focus();
      }
    },

    onDateSelected(date) {
      this.isOpen = false;
      this.selectedDate = Date.parse(date);
      this.$refs.input.focus();
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Calendar/DatePicker.vue_rollup-plugin-vue=script.js